import { StackScrollTool, ZoomTool } from "@cornerstonejs/tools";
import { DirectionalHint, TooltipDelay, TooltipHost } from "@fluentui/react";
import React, { useContext, useEffect, useRef, useState } from "react";
import DropDown from "../../../../../components/SVGComponents/Tools/DropDown";
import { isMobile } from "react-device-detect";
import { STACK_SCROLL_DROPDOWN_ELEMENTS } from "../../../../../constants/Constants";
import themeContext from "../../../../../context/theme/ThemeContext";
import ViewportContext from "../../../../../context/studyviewer/ViewportContext";
import StackScroll from "../../../../../components/SVGComponents/Tools/StackScroll";
import studyviewerContext from "../../../../../context/studyviewer/StudyviewerContext";
import ThumbnailContext from "../../../../../context/studyviewer/ThumbnailContext";
import Zoom from "../../../../../components/SVGComponents/Zoom";
import {
  fitToScreen,
  originalResolution,
  resizeViewport,
} from "../../../helpers/CornerstoneViewportService";
import userContext from "../../../../../context/users/UserContext";
import { toolTipStyles } from "../../../styles/styles";
import { t } from "i18next";
import CustomToolTipHost from "../../../../../components/CustomToolTipHost/CustomToolTipHost";
import {
  createMouseButtonAssignmentPointerDownCaptureHandler,
  suppressMouseButtonAssignmentContextMenu,
  ToolbarMouseAssignmentIndicators,
} from "./mouseButtonToolbarUtils";

const ZoomToolComponent = ({ tool }) => {
  const dropDownRef = useRef(null);
  const buttonRef = useRef(null);
  const [menuPos, setMenuPos] = useState({ bottom: 0, left: 0 });
  const { theme } = useContext(themeContext);
  const [showDropDown, setShowDropDown] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [dropDownHovered, setDropDownHovered] = useState(false);
  const {
    activeTool,
    setActiveTool,
    setPreviousActiveTool,
    activeMPRTool,
    isMPRActive,
    activeViewportIndex,
    activeMPRViewportIndex,
    handleDefaultToolChange,
    boundingBoxMode,
    setBoundingBoxMode,
    isCropEnable,
    setIsCropEnable,
    assignMouseButtonToAssignableTool,
    mouseButtonToolAssignments,
  } = useContext(ViewportContext);
  const { username } = useContext(userContext);
  const changeActiveTool = async (tool) => {
    // eventTarget.reset();
    const isBBMode = boundingBoxMode;
    const isCropMode =  isCropEnable;

    setIsCropEnable(false);
    setBoundingBoxMode(false);
    
    
    if (!isBBMode && !isCropMode &&activeTool === tool.key) {
      setPreviousActiveTool(activeTool);
      handleDefaultToolChange();
    } else {
      setPreviousActiveTool(activeTool);
      assignMouseButtonToAssignableTool("primary", tool.key, true);
      setActiveTool(tool.key);
    }
  };

  const handleMouseLeave = () => {
    setHovered(false);
  };

  const handleMouseOver = () => {
    setHovered(true);
  };

  const handleDropDownClick = () => {
    // On mobile the toolbar is at the bottom (and may sit inside the More grid),
    // so anchor the dropdown above the icon using its live rect (fixed pos).
    if (!showDropDown && isMobile && buttonRef.current) {
      const rect = buttonRef.current.getBoundingClientRect();
      setMenuPos({ bottom: window.innerHeight - rect.top + 6, left: rect.left });
    }
    setShowDropDown(!showDropDown);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropDownRef.current && !dropDownRef.current.contains(event.target)) {
        setShowDropDown(false);
      }
    };
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  const handleFitToScreen = async () => {
    if (isMPRActive) {
      await fitToScreen(activeMPRViewportIndex, isMPRActive);
    } else {
      await fitToScreen(activeViewportIndex, isMPRActive);
    }
    resizeViewport();
    setShowDropDown(false);
  };

  const handleOriginalResolution = async () => {
    if (isMPRActive) {
      await originalResolution(activeMPRViewportIndex, isMPRActive);
    } else {
      await originalResolution(activeViewportIndex, isMPRActive);
    }
    resizeViewport();
    setShowDropDown(false);
  };

  return (
    <>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            height: "100%",
            position: "relative",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <div
            ref={buttonRef}
            style={{
              height: "100%",
              width: `${isMobile ? "60px" : "100%"}`,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <div
              style={{
                height: isMobile ? "65%" : "100%",
                display: "flex",
                alignItems: "center",
              }}
            >
              <div
                className={
                  isMobile ? "highlight-tool-mobile" : "highlight-tool"
                }
                style={{ width: isMobile ? undefined : "55px" }}
              >
                <CustomToolTipHost
                  delay={TooltipDelay.zero}
                  id={"zoomtool"}
                  directionalHint={DirectionalHint.rightCenter}
                  styles={toolTipStyles}
                  content={isMobile ? "" : t("viewer.tools.zoom-tool")}
                  className={"myToolTip"}
                >
                  <div
                    className={!isMobile ? "tool-with-mouse" : ""}
                    style={{
                      height: "100%",
                      position: "relative",
                    }}
                    onClick={() => changeActiveTool(tool)}
                    onPointerDownCapture={createMouseButtonAssignmentPointerDownCaptureHandler(
                      ZoomTool.toolName,
                      assignMouseButtonToAssignableTool
                    )}
                    onContextMenu={suppressMouseButtonAssignmentContextMenu}
                    onContextMenuCapture={suppressMouseButtonAssignmentContextMenu}
                    onMouseOver={handleMouseOver}
                    onMouseLeave={handleMouseLeave}
                  >
                    <Zoom
                      color={
                        (isMPRActive && activeMPRTool === ZoomTool.toolName) ||
                        activeTool === ZoomTool.toolName ||
                        (!isMobile && hovered)
                          ? theme.palette.activeTool
                          : theme.palette.inactiveTool
                      }
                    />
                    {!isMobile && (
                      <ToolbarMouseAssignmentIndicators
                        toolName={ZoomTool.toolName}
                        assignments={mouseButtonToolAssignments}
                      />
                    )}
                  </div>
                </CustomToolTipHost>
                <div
                  style={{
                    // Wider than the Rotation/HP tools' 4px gap: on desktop this icon can
                    // show the mouse-button assignment badge (bottom-right corner, protrudes
                    // ~9px past the icon), which would otherwise overlap the arrow. The badge
                    // never renders on mobile, so mobile keeps the tighter gap.
                    marginLeft: isMobile ? "4px" : "14px",
                    display: "flex",
                    alignItems: "center",
                    height: "100%",
                  }}
                  onClick={handleDropDownClick}
                  onMouseOver={() => setDropDownHovered(true)}
                  onMouseLeave={() => setDropDownHovered(false)}
                >
                  <DropDown up={isMobile}
                    color={
                      dropDownHovered || hovered
                        ? theme.palette.activeTool
                        : theme.palette.inactiveTool
                    }
                  />
                </div>
              </div>
            </div>
            {isMobile && (
              <span
                style={{
                  fontSize: "9px",
                  lineHeight: "100%",
                  fontWeight: "400",
                  //color: "#FFFFFF",
                  //color: "var(--navbar-header-popup-color-txt)",
                  color: "var(--mobile-color-txt)",
                }}
              >
                {t("viewer.tools.zoom")}
              </span>
            )}
          </div>
        </div>

        {showDropDown && (
          <div
            className={
              isMobile ? "viewer-tool-more-dropdown" : "dropdow-top-position viewer-tool-more-dropdown"
            }
            ref={dropDownRef}
            style={{
              flexDirection: "column",
              position: isMobile ? "fixed" : "absolute",
              ...(isMobile ? { bottom: menuPos.bottom, left: menuPos.left } : {}),
              // top : window.innerHeight * 0.075,
              zIndex: "999",
              // backgroundColor: "#201F1E",
              boxShadow:
                "0px 0.6px 1.8px rgba(0, 0, 0, 0.1), 0px 3.2px 7.2px rgba(0, 0, 0, 0.13)",
              borderRadius: "5px",
              paddingLeft: "10px",
              paddingRight: "20px",
            }}
          >
            <div
              onClick={handleFitToScreen}
              className="stack-scroll-dropdown-elements"
            >
              {t("viewer.tools.fit-to-screen")}
            </div>
            <div
              onClick={handleOriginalResolution}
              className="stack-scroll-dropdown-elements"
            >
              {t("viewer.tools.original-zoom")}
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default ZoomToolComponent;
